namespace TabAurous.Retail {
    export namespace POSSalesGiftVoucherService {
        export const baseUrl = 'Retail/POSSalesGiftVoucher';

        export declare function Create(request: Serenity.SaveRequest<POSSalesGiftVoucherRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<POSSalesGiftVoucherRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<POSSalesGiftVoucherRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesGiftVoucherRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Retail/POSSalesGiftVoucher/Create",
            Update = "Retail/POSSalesGiftVoucher/Update",
            Delete = "Retail/POSSalesGiftVoucher/Delete",
            Retrieve = "Retail/POSSalesGiftVoucher/Retrieve",
            List = "Retail/POSSalesGiftVoucher/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>POSSalesGiftVoucherService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
